import React, { PropsWithChildren, useContext } from 'react'

import { concatStyles, remCalc } from 'utils'
import { NavigatorContext } from './NavigatorContext'

const DRAWER_GENERIC_STYLES = 'flex flex-row relative list-none box-border m-0'
const CONTENT_STYLES = 'flex-1 p-4'
const DIVIDER_STYLES = 'block absolute border-b border-solid bg-navdivider'

interface GenericProps {
  className?: string
  style?: React.CSSProperties
}

/**
 * A generic container for alternate content embedded in
 * the primary navigation drawer.
 */
export const Generic: React.FC<PropsWithChildren<GenericProps>> = ({
  children,
  className,
  style,
}) => {
  const { theme } = useContext(NavigatorContext)
  const isSecondary: boolean = theme === 'secondary'

  return (
    <li
      className={concatStyles(DRAWER_GENERIC_STYLES, className)}
      style={style}
    >
      <div className={CONTENT_STYLES}>{children}</div>
      <span
        style={{
          bottom: -1,
          left: isSecondary ? remCalc(18) : 0,
          right: isSecondary ? remCalc(18) : 0,
        }}
        className={concatStyles([
          DIVIDER_STYLES,
          isSecondary ? 'bg-navdivideralt' : '',
        ])}
      />
    </li>
  )
}
